// extracted by mini-css-extract-plugin
module.exports = {"leftButton":"style_leftButton__2B9Gy"};